import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { Models } from '.';
import { IEmployeeCollectionProps } from '../components/employee-collection/employee-collection';
import { ITextProps } from '../components/text/text';
import { TextModel } from './text-model';

export class EmployeesCollectionModel extends ContentItem {
  get employeeCollection(): IEmployeesCollection[] {
    const getPersons = get(
      this._config,
      'elements.collection_of_employees.value',
      []
    );
    const transformPersons = getPersons
      ? getPersons.map((person: IKontentItem) =>
          Models.EmployeeBoxModel.create(person as IEmployeeBox)
        )
      : null;
    return transformPersons;
  }

  get contactText(): ITextProps[] {
    const items = get(this._config, 'elements.contact_text.value', []);
    const modeledTexts = items.map((text: IText) =>
      TextModel.create(text as IText)
    );
    return modeledTexts;
  }

  get contactBtnText(): string {
    return get(this._config, 'elements.contact_btn_text.value', '');
  }

  get showMoreText(): string {
    return get(this._config, 'elements.show_more_text.value', '');
  }

  get contactMail(): string {
    return get(this._config, 'elements.contact_mail.value', '');
  }

  public static create(data: IEmployeesCollection): IEmployeeCollectionProps {
    const {
      employeeCollection,
      contactText,
      contactBtnText,
      showMoreText,
      contactMail
    } = new EmployeesCollectionModel(data);
    return {
      employeeCollection,
      contactText,
      contactBtnText,
      showMoreText,
      contactMail
    };
  }
}
